import React from 'react';
import { Avatar, Input } from '@spark';
import SettingsSectionCard from './SettingsSectionCard.jsx';
import './settings.css';

/**
 * Profile Information tab (Figma frame 6001-261): 48px avatar with name +
 * email, disabled First/Last/Email inputs (360px), email helper text, and a
 * disabled read-only Timezone input.
 */
const ProfileInformation = ({ profile }) => {
    const { firstName, lastName, email, timezone, name, picture } = profile || {};

    return (
        <SettingsSectionCard iconSlug="user" title="Profile Information">
            <Avatar
                size="large"
                type={picture ? 'image' : 'initials'}
                src={picture || undefined}
                alt={name || email || 'Avatar'}
                primaryText={name || email || ''}
                secondaryText={email || ''}
                showContent
            />

            <div className="settings-form">
                <div className="settings-profile__names">
                    <Input
                        label="First Name"
                        size="large"
                        value={firstName || ''}
                        disabled
                        placeholder=""
                    />
                    <Input
                        label="Last Name"
                        size="large"
                        value={lastName || ''}
                        disabled
                        placeholder=""
                    />
                </div>

                <Input
                    label="Email Address"
                    size="large"
                    value={email || ''}
                    disabled
                    placeholder=""
                    showHelperText
                    helperText="Need to update your Email? Contact your admin"
                />

                <Input
                    label="Timezone"
                    size="large"
                    value={timezone || ''}
                    disabled
                    placeholder=""
                />
            </div>
        </SettingsSectionCard>
    );
};

export default ProfileInformation;
